import { apiClient } from './client';

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface MeResponse {
  user: {
    id: number;
    email: string;
    role: string;
    first_name: string;
    last_name: string;
    is_verified: boolean;
  };
  patients: { id: number; first_name: string; last_name: string }[];
}

export interface SignupRequest {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: string;
  patient_first_name?: string;
  patient_last_name?: string;
  patient_date_of_birth?: string;
}

export interface SignupResponse {
  message: string;
  user_id: number;
}

export const login = async (data: { email: string; password: string }): Promise<LoginResponse> => {
  const response = await apiClient.post('/auth/login', data);
  return response.data;
};

export const getMe = async (): Promise<MeResponse> => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

export const signup = async (data: SignupRequest): Promise<SignupResponse> => {
  const response = await apiClient.post('/auth/signup', data);
  return response.data;
};

export const verifyEmail = async (token: string): Promise<{ message: string }> => {
  const response = await apiClient.get(`/auth/verify/${token}`);
  return response.data;
};

export const resendVerification = async (email: string): Promise<{ message: string }> => {
  const response = await apiClient.post('/auth/resend-verification', { email });
  return response.data;
};

export const forgotPassword = async (email: string): Promise<{ message: string }> => {
  const response = await apiClient.post('/auth/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (token: string, password: string): Promise<{ message: string }> => {
  const response = await apiClient.post('/auth/reset-password', { token, password });
  return response.data;
};

export const sendInvite = async (data: { patient_id: number; invited_email: string; invited_role: string }): Promise<{ message: string; invitation_id: number }> => {
  const response = await apiClient.post('/auth/invite', data);
  return response.data;
};

export const getInvitation = async (token: string): Promise<{ email: string; role: string; patient_first_name: string; patient_last_name: string }> => {
  const response = await apiClient.get(`/auth/invite/${token}`);
  return response.data;
};

export const acceptInvite = async (token: string): Promise<{ message: string; patient_id: number }> => {
  const response = await apiClient.post('/auth/accept-invite', { token });
  return response.data;
};